import StyledHome from "./Home";
export const Home = StyledHome;
